<template>
  <PillBadge
    sober
    :straighten-corner="straightenCorner"
    :class="['year-pill', isCurrentYear && 'year-pill--current-year']"
  >
    {{ year }}
  </PillBadge>
</template>

<script>
import PillBadge from '@/components/shared/PillBadge.vue'

export default {
  name: 'YearPill',
  components: {
    PillBadge,
  },
  props: {
    year: {
      type: String,
      required: false,
      default: () => {
        return `${new Date().getFullYear()}`
      },
    },
    placement: {
      type: String,
      required: false,
      default: '',
    },
    straightenCorner: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    isCurrentYear() {
      return this.year === `${new Date().getFullYear()}`
    },
  },
}
</script>

<style lang="scss" scoped>
.year-pill {
  color: var(--white);
  font-size: rem(12px);
  font-style: normal;
  font-weight: 450;
  line-height: rem(14px);
  padding: 5px 10px;
  border-radius: 10px;
  border: none;
  &--current-year {
    color: var(--strong-light-green);
    font-weight: 700;
  }
}
</style>
